import { useState } from "react";
import { PlusCircle, Trash2 } from "lucide-react";

const VehicleDetails = ({
  id,
  index,
  vehicles,
  setVehicles,
  handleChange,
  errors,
  product,
  handleAddVehicle,
  handleRemoveVehicle,
}) => {
  const [showForm, setShowForm] = useState(true);

  const handleRadioChange = (isYes) => {
    setShowForm(isYes);
  };

  const handleClick = (e, id) => {
    const updatedVehicles = vehicles.map((vehicle, idx) =>
      idx === id
        ? {
          ...vehicle,
          [e.target.name]: e.target.value === "TBC" ? "" : e.target.value,
        }
        : vehicle
    );
    setVehicles(updatedVehicles);
  };

  const handleBlur = (e, id) => {
    const { name, value } = e.target;
    setVehicles((prevVehicles) =>
      prevVehicles.map((vehicle, idx) => {
        if (idx === id) {
          return {
            ...vehicle,
            [name]: value || ((product?.api_tag || product?.option_id) ? "" : "TBC"),
          };
        }
        return vehicle;
      })
    );
  };

  const handleOrdinalSuffixOf = (i) => {
    const j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) return i + "st";
    if (j === 2 && k !== 12) return i + "nd";
    if (j === 3 && k !== 13) return i + "rd";
    return i + "th";
  };

  return (
    <div className="mx-auto rounded-2xl shadow-md bg-white border border-slate-200 overflow-hidden mt-5">
      {/* Header bar */}
      <div className="bg-gradient-to-r from-primary from-[80%] to-secondary px-6 py-4 text-white font-semibold text-lg md:text-xl flex flex-wrap justify-between items-center gap-3">
        <span>
          {vehicles.length > 1 ? `${handleOrdinalSuffixOf(index + 1)} ` : ""}Car Details
        </span>

        <div className="flex items-center gap-3">
          {/* Toggle pill */}
          <div className="flex bg-[#001D16]/50 p-1 rounded-xl border border-white/10 select-none">
            <button
              type="button"
              className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 ${showForm
                ? "bg-secondary text-primary shadow-sm"
                : "bg-transparent text-white/80 hover:text-white"
                }`}
              onClick={() => handleRadioChange(true)}
            >
              Yes
            </button>
            <button
              type="button"
              className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 ${!showForm
                ? "bg-secondary text-primary shadow-sm"
                : "bg-transparent text-white/80 hover:text-white"
                }`}
              onClick={() => handleRadioChange(false)}
            >
              No
            </button>
          </div>

          {/* Add 2nd Car Button - Show on first car only */}
          {/* {index === 0 && (
            <button
              type="button"
              onClick={handleAddVehicle}
              className="flex items-center gap-2 bg-[#001D16]/60 border border-white/20 hover:bg-[#001D16]/80 text-white font-semibold px-4 py-1.5 rounded-xl text-sm transition-all shadow-sm"
            >
              <span>Add 2nd Car</span>
              <PlusCircle className="w-4 h-4 text-secondary" />
            </button>
          )} */}

          {/* Remove Car Button - Show on subsequent cars */}
          {/* {index > 0 && (
            <button
              type="button"
              onClick={(e) => handleRemoveVehicle(e, index)}
              className="flex items-center gap-2 bg-red-950/60 border border-red-500/20 hover:bg-red-900/60 text-red-200 font-semibold px-4 py-1.5 rounded-xl text-sm transition-all shadow-sm"
            >
              <span>Remove</span>
              <Trash2 className="w-4 h-4 text-red-400" />
            </button>
          )} */}
        </div>
      </div>

      <div className="p-3 md:p-6">
        <p className="text-sm font-medium text-slate-500 mb-4">
          Do you have vehicle details?
        </p>

        {/* Vehicle details form */}
        {showForm && (
          <div className="transition-all duration-500 ease-in-out">
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

              {/* Make Input */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Make*</label>
                <input
                  type="text"
                  name="make"
                  placeholder="make"
                  className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "make")
                    ? vehicles[index]["make"]?.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                    }`}
                  value={vehicles[index]["make"] || ""}
                  onChange={(e) => handleChange(e, id)}
                  onClick={(e) => handleClick(e, id)}
                  onBlur={(e) => handleBlur(e, id)}
                />
              </div>

              {/* Model Input */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Model*</label>
                <input
                  type="text"
                  name="model"
                  placeholder="model"
                  className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "model")
                    ? vehicles[index]["model"]?.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                    }`}
                  value={vehicles[index]["model"] || ""}
                  onChange={(e) => handleChange(e, id)}
                  onClick={(e) => handleClick(e, id)}
                  onBlur={(e) => handleBlur(e, id)}
                />
              </div>

              {/* Color Input */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Color*</label>
                <input
                  type="text"
                  name="color"
                  placeholder="color"
                  className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "color")
                    ? vehicles[index]["color"]?.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                    }`}
                  value={vehicles[index]["color"] || ""}
                  onChange={(e) => handleChange(e, id)}
                  onClick={(e) => handleClick(e, id)}
                  onBlur={(e) => handleBlur(e, id)}
                />
              </div>

              {/* Reg Number Input */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Reg Number*</label>
                <input
                  type="text"
                  name="reg_no"
                  placeholder="reg number"
                  className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "reg_no")
                    ? vehicles[index]["reg_no"]?.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                    }`}
                  value={vehicles[index]["reg_no"] || ""}
                  onChange={(e) => handleChange(e, id)}
                  onClick={(e) => handleClick(e, id)}
                  onBlur={(e) => handleBlur(e, id)}
                />
              </div>

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleDetails;
